// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"HZ-z","subtitle":"IZ-z","wrapper":"JZ-z","leftArrow":"KZ-z","rightArrow":"LZ-z"};